/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { } from '../../store/actions';

// i18n
import { withTranslation } from 'react-i18next';
import SidebarContent from './SidebarContent';

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="vertical-menu">
        <div data-simplebar className="h-100">
          {this.props.type !== 'condensed' ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background" />
      </div>
    );
  }
}

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStateToProps = (state) => ({
  layout: state.Layout,
});
export default connect(
  mapStateToProps,
  {},
)(withRouter(withTranslation()(Sidebar)));
